export function getRange(startYear, endYear) {
  const years = [];
  while (startYear <= endYear) {
    years.push(startYear++);
  }
  return years;
}
